// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UndoRemoveToast-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 16px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectedItemsBar/components/UndoRemoveToast/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AACF","sourcesContent":[".UndoRemoveToast-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  column-gap: 16px;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
